import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalBlock({ title, children }) {
  return (
    <div className="space-y-3">
      {title && <h2 className="font-heavy text-xl uppercase text-white">{title}</h2>}
      <div className="space-y-2 text-[15px] leading-relaxed text-white/70">{children}</div>
    </div>
  );
}

export default function LegalShell({ title, subtitle, children }) {
  return (
    <section className="relative min-h-screen bg-transparent px-5 pb-28 pt-36 md:px-10">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="mono-label mb-8 inline-flex items-center gap-2 text-xs text-white/60 transition-colors hover:text-[var(--crtr-yellow)]"
        >
          <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-display text-5xl text-white sm:text-6xl">
          {title}
          <span className="text-[var(--crtr-yellow)]">.</span>
        </h1>
        {subtitle && <p className="mt-4 text-white/60">{subtitle}</p>}
        <div className="mt-12 space-y-10">{children}</div>
      </div>
    </section>
  );
}
